import React, { useState } from "react";
import { useEffect } from "react";
import { Card, Form } from "react-bootstrap";
import {
  convertValue,
  formatValue,
  showValue,
} from "../../../services/helperService";
import capitalList from "../../../constants/benefits/capital_legacy_reates.json";
import seniorList from "../../../constants/benefits/senior_choice_rates.json";
import moment from "moment";
import { usePlannerContext } from "../../../contexts/planner.contexts";
import CompoundInterestTool from "./CompoundInterestTool";

import jwt_decode from "jwt-decode";

const BenefitTestForm = ({ submit, formData }) => {
  const { plannerData } = usePlannerContext();

  const [isCapitalLegacy, setCapitalLegacy] = useState(true);
  const [legencyDetail, setLegencyDetail] = useState({});
  const [decodedToken, setDecodedToken] = useState({});
  const [showButtons, setshowButtons] = useState([false, false, false]);
  const [classicAmount, setClassicAmount] = useState(0);

  const [principal, setPrincipal] = useState();
  const [rate, setRate] = useState(4.5);

  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    let legacyStatus = true;
    let payload = {};
    const dobDate = moment(formData["dob"]);
    let age = moment().diff(dobDate, "years", true);
    let legencyList = capitalList;

    const localToken = localStorage.getItem("token");

    setDecodedToken(jwt_decode(localToken));

    if (age) {
      if (age >= 55) {
        legacyStatus = false;
        legencyList = seniorList;
      }
      age = Math.floor(age);
    } else {
      age = 0;
    }
    const legencyData = legencyList.find((item) => item["age"] == age);
    if (legencyData) {
      const lifeInsuranceCapital = [
        {
          name: "Year 1",
          value: formatValue(legencyData["li_amnt_year_1"]),
          protection: formatValue(legencyData["pro_amnt_year_1"]),
        },
        {
          name: "Year 2",
          value: formatValue(legencyData["li_amnt_year_2"]),
          protection: formatValue(legencyData["pro_amnt_year_2"]),
        },
        {
          name: "Year 11",
          value: formatValue(legencyData["li_amnt_year_11"]),
          protection: formatValue(legencyData["pro_amnt_year_11"]),
        },
        {
          name: "Age 65",
          value: formatValue(legencyData["li_amnt_age_65"]),
          protection: formatValue(legencyData["pro_amnt_age_65"]),
        },
      ];

      const lifeInsuranceSenior = [
        {
          name: "Year 1",
          value: formatValue(legencyData["li_amnt_year_1"]),
          protection: formatValue(legencyData["pro_amnt_year_1"]),
        },
      ];

      const otherInsuranceCapital = [
        {
          name: "Year 1",
          value: formatValue(legencyData["ri_amnt_year_1"]),
          protection: formatValue(legencyData["val_at_1_per_year_1"]),
        },
        {
          name: "Year 2",
          value: formatValue(legencyData["ri_amnt_year_2"]),
          protection: formatValue(legencyData["val_at_1_per_year_2"]),
        },
        {
          name: "Year 11",
          value: formatValue(legencyData["ri_amnt_year_11"]),
          protection: formatValue(legencyData["val_at_1_per_year_11"]),
        },
        {
          name: "Age 65",
          value: formatValue(legencyData["ri_amnt_age_65"]),
          protection: formatValue(legencyData["val_at_1_per_age_65"]),
        },
      ];

      let otherInsuranceSenior = [
        {
          name: "Year 1",
          value: formatValue(legencyData["trade_amnt_year_1"]),
          protection: formatValue(legencyData["val_at_1_per_year_1"]),
        },
      ];

      if (age <= 65) {
        otherInsuranceSenior = [
          ...otherInsuranceSenior,
          {
            name: "Age 65",
            value: formatValue(legencyData["trade_amnt_age_65"]),
            protection: formatValue(legencyData["val_at_1_per_age_65"]),
          },
        ];
      }
      if (age <= 70) {
        otherInsuranceSenior = [
          ...otherInsuranceSenior,
          {
            name: "Age 70",
            value: formatValue(legencyData["trade_amnt_age_70"]),
            protection: formatValue(legencyData["val_at_1_per_age_70"]),
          },
        ];
      }
      payload = {
        title: legacyStatus
          ? "The Capital Legacy Benefits Solution"
          : "The Senior Choice Benefit Solution",
        "bi-weekly": legacyStatus ? "$105" : "$" + legencyData["bwlc"],
        secondTitle: legacyStatus ? "ROTH IRA" : "FPAR (Optional)",
        lifeInsurance: legacyStatus
          ? lifeInsuranceCapital
          : lifeInsuranceSenior,
        otherInsurance: legacyStatus
          ? otherInsuranceCapital
          : otherInsuranceSenior,
      };
    } else {
      payload = {
        title: "CAPITAL LEGACY",
        "bi-weekly": "$105",
        secondTitle: "ROTH IRA",
        lifeInsurance: {
          name: "N/A",
          value: "N/A",
          protection: "N/A",
        },
        otherInsurance: {
          name: "N/A",
          value: "N/A",
          protection: "N/A",
        },
      };
    }
    if (!legacyStatus) {
      setClassicAmount(parseInt(convertValue(formData.basic_life) * 0.25));
    }
    setLegencyDetail(payload);
    setCapitalLegacy(legacyStatus);
  }, [formData["dob"]]);

  const onMouseEnterHandler = (id) => {
    setshowButtons((prevState) => {
      const newState = [...prevState];
      newState[id - 1] = true;
      return newState;
    });
  };

  const onmouseleaveHandler = (id) => {
    setshowButtons((prevState) => {
      const newState = [...prevState];
      newState[id - 1] = false;
      return newState;
    });
  };

  const capitalBenefits = () => (
    <div className="content-box">
      <p className="box-title">{legencyDetail["title"]}</p>
      <p className="box-sub-title">Benefit Worksheet</p>
      <button
        type="button"
        className="btn btn-link p-0"
        onClick={() => setModalOpen(true)}
        style={{ position: "absolute", top: "10px", right: "10px" }}
      >
        <i className="fa fa-calculator fa-2x"></i>
      </button>

      {modalOpen && (
        <CompoundInterestTool
          retirementDate={moment(formData["desired_retirement_date"]).format(
            "YYYY-MM-DD"
          )}
          rate={rate}
          setRate={setRate}
          principal={principal}
          setPrincipal={setPrincipal}
          onClose={() => setModalOpen(false)}
        />
      )}
      <div className="container pt-5">
        <div className="row">
          <div
            className="col-md-4"
            onMouseEnter={(e) => onMouseEnterHandler(1)}
            onMouseLeave={(e) => onmouseleaveHandler(1)}
          >
            <div className="col-11 mx-auto box-cont">
              <div
                className="title-1 text-center"
                style={{ backgroundColor: "#ccc", borderColor: "#ccc" }}
              >
                CLASSIC
              </div>
              <div className="price-1 text-center">
                $<span>110</span>
              </div>
              <p className="text-center price-text-1">bi-weekly contribution</p>
              <table className="text-start mb-3 years-table">
                <colgroup>
                  <col span="1" style={{ width: "25%" }} />
                  <col span="1" style={{ width: "75%" }} />
                </colgroup>
                <tr>
                  <td>Year 1:</td>
                  <td>$104pp / $5 ROTH IRA</td>
                </tr>
                <tr>
                  <td>Year 2+:</td>
                  <td>$52pp / $57 ROTH IRA</td>
                </tr>
                <tr>
                  <td style={{ alignContent: "baseline" }}>Year 11:</td>
                  <td>Year 1 insurance costs deposited into ROTH</td>
                </tr>
              </table>
              <hr />
              <ul className="text-start pb-2">
                <li>Level Premium</li>
                <li>Portable</li>
                <li>OBA Add-on Available</li>
                <li>Paid Up Option After 10 Years</li>
                <li>Emergency Cash Options</li>
                <li>Critical Care Rider</li>
                <li>Furlough Protection</li>
                <li>
                  Guaranteed Return
                  <ul className="text-start pb-2" style={{ listStyle: "disc" }}>
                    <li>Current Rate: 4.5%</li>
                    <li>Guaranteed Rate: 2.7%</li>
                  </ul>
                </li>
              </ul>
              {showButtons[0] ? (
                <div className="text-center">
                  <a
                    href="https://www.insuranceapplication.com/"
                    className="btn btn-primary btnSeeIfIQualify2 benefits-btn-1"
                    target="_blank"
                  >
                    See If I Qualify
                  </a>
                </div>
              ) : (
                <div className="text-center h-btn">
                  <a
                    href="https://www.insuranceapplication.com/"
                    className="btn btn-primary btnSeeIfIQualify2 benefits-btn-1"
                    target="_blank"
                  >
                    See If I Qualify
                  </a>
                </div>
              )}
            </div>
          </div>
          <div
            className="col-md-4"
            onMouseEnter={(e) => onMouseEnterHandler(2)}
            onMouseLeave={(e) => onmouseleaveHandler(2)}
          >
            <div className="col-11 mx-auto box-cont">
              <div
                className="title-1 text-center"
                style={{ backgroundColor: "#255786", borderColor: "#255786" }}
              >
                TRADITIONAL
              </div>
              <div className="price-1 text-center">
                $<span>125</span>
              </div>
              <p className="text-center price-text-1">bi-weekly contribution</p>
              <table className="text-start mb-3 years-table">
                <colgroup>
                  <col span="1" style={{ width: "25%" }} />
                  <col span="1" style={{ width: "75%" }} />
                </colgroup>
                <tr>
                  <td>Year 1:</td>
                  <td>$119pp / $5 ROTH IRA</td>
                </tr>
                <tr>
                  <td>Year 2+:</td>
                  <td>$59.50pp / $64.50 ROTH IRA</td>
                </tr>
                <tr>
                  <td style={{ alignContent: "baseline" }}>Year 11:</td>
                  <td>Year 1 insurance costs deposited into ROTH</td>
                </tr>
              </table>
              <hr />
              <ul className="text-start pb-2">
                <li>Level Premium</li>
                <li>Portable</li>
                <li>OBA Add-on Available</li>
                <li>Paid Up Option After 10 Years</li>
                <li>Emergency Cash Options</li>
                <li>Critical Care Rider</li>
                <li>Furlough Protection</li>
                <li>
                  Guaranteed Return
                  <ul className="text-start pb-2" style={{ listStyle: "disc" }}>
                    <li>Current Rate: 4.5%</li>
                    <li>Guaranteed Rate: 2.7%</li>
                  </ul>
                </li>
              </ul>
              {showButtons[1] ? (
                <div className="text-center">
                  <a
                    href="https://www.insuranceapplication.com/"
                    className="btn btn-primary btnSeeIfIQualify2 benefits-btn-1"
                    target="_blank"
                  >
                    See If I Qualify
                  </a>
                </div>
              ) : (
                <div className="text-center h-btn">
                  <a
                    href="https://www.insuranceapplication.com/"
                    className="btn btn-primary btnSeeIfIQualify2 benefits-btn-1"
                    target="_blank"
                  >
                    See If I Qualify
                  </a>
                </div>
              )}
            </div>
          </div>
          <div
            className="col-md-4"
            onMouseEnter={(e) => onMouseEnterHandler(3)}
            onMouseLeave={(e) => onmouseleaveHandler(3)}
          >
            <div className="col-11 mx-auto box-cont">
              <div
                className="title-1 text-center"
                style={{ backgroundColor: "#ABABAB", borderColor: "#ABABAB" }}
              >
                PREFERRED
              </div>
              <div className="price-1 text-center">
                $<span>140</span>
              </div>
              <p className="text-center price-text-1">bi-weekly contribution</p>
              <table className="text-start mb-3 years-table">
                <colgroup>
                  <col span="1" style={{ width: "25%" }} />
                  <col span="1" style={{ width: "75%" }} />
                </colgroup>
                <tr>
                  <td>Year 1:</td>
                  <td>$134pp / $5 ROTH IRA</td>
                </tr>
                <tr>
                  <td>Year 2+:</td>
                  <td>$67pp / $72 ROTH IRA</td>
                </tr>
                <tr>
                  <td style={{ alignContent: "baseline" }}>Year 11:</td>
                  <td>Year 1 insurance costs deposited into ROTH</td>
                </tr>
              </table>
              <hr />
              <ul className="text-start pb-2">
                <li>Level Premium</li>
                <li>Portable</li>
                <li>OBA Add-on Available</li>
                <li>Paid Up Option After 10 Years</li>
                <li>Emergency Cash Options</li>
                <li>Critical Care Rider</li>
                <li>Furlough Protection</li>
                <li>
                  Guaranteed Return
                  <ul className="text-start pb-2" style={{ listStyle: "disc" }}>
                    <li>Current Rate: 4.5%</li>
                    <li>Guaranteed Rate: 2.7%</li>
                  </ul>
                </li>
              </ul>
              {showButtons[2] ? (
                <div className="text-center">
                  <a
                    href="https://www.insuranceapplication.com/"
                    className="btn btn-primary btnSeeIfIQualify2 benefits-btn-1"
                    target="_blank"
                  >
                    See If I Qualify
                  </a>
                </div>
              ) : (
                <div className="text-center h-btn">
                  <a
                    href="https://www.insuranceapplication.com/"
                    className="btn btn-primary btnSeeIfIQualify2 benefits-btn-1"
                    target="_blank"
                  >
                    See If I Qualify
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const seniorBenefits = () => (
    <div className="content-box">
      <p className="box-title">{legencyDetail["title"]}</p>
      <p className="box-sub-title">Benefit Worksheet</p>
      <div className="container pt-5" style={{ paddingBottom: "6rem" }}>
        <div className="row">
          {classicAmount < 50000 && (
            <div
              className="col-md-4 mx-auto"
              onMouseEnter={(e) => onMouseEnterHandler(1)}
              onMouseLeave={(e) => onmouseleaveHandler(1)}
            >
              <div className="col-11 mx-auto box-cont">
                <div
                  className="title-1 text-center"
                  style={{ backgroundColor: "#ccc", borderColor: "#ccc" }}
                >
                  CLASSIC
                </div>
                <div className="price-1 text-center">
                  $<span>{showValue(classicAmount).replace("$", "")}</span>
                </div>
                <p className="text-center price-text-1">
                  Permanent Life Insurance Coverage
                </p>
                <ul className="text-start pb-2">
                  <li>Level Premium</li>
                  <li>Portable</li>
                  <li>Emergency Cash Options</li>
                  <li>Guarantee Coverage Amount</li>
                </ul>
                <div className="black-strip mb-2">FPAR (Optional)</div>
                <ul className="text-start pb-2">
                  <li>
                    Compound Interest
                    <ul
                      className="text-start pb-2"
                      style={{ listStyle: "disc" }}
                    >
                      <li>Current Rate: 4.5%</li>
                      <li>Guaranteed Rate: 2.7%</li>
                    </ul>
                  </li>
                  <li>No Investment Risk</li>
                  <li>Income for Life Option</li>
                </ul>
                {showButtons[0] ? (
                  <div className="text-center">
                    <a
                      href="https://www.insuranceapplication.com/"
                      className="btn btn-primary btnSeeIfIQualify2 benefits-btn-1"
                      target="_blank"
                    >
                      See If I Qualify
                    </a>
                  </div>
                ) : (
                  <div className="text-center h-btn">
                    <a
                      href="https://www.insuranceapplication.com/"
                      className="btn btn-primary btnSeeIfIQualify2 benefits-btn-1"
                      target="_blank"
                    >
                      See If I Qualify
                    </a>
                  </div>
                )}
              </div>
            </div>
          )}
          {classicAmount < 35000 && (
            <div
              className="col-md-4 mx-auto"
              onMouseEnter={(e) => onMouseEnterHandler(2)}
              onMouseLeave={(e) => onmouseleaveHandler(2)}
            >
              <div className="col-11 mx-auto box-cont">
                <div
                  className="title-1 text-center"
                  style={{ backgroundColor: "#255786", borderColor: "#255786" }}
                >
                  TRADITIONAL
                </div>
                <div className="price-1 text-center">
                  $<span>35,000</span>
                </div>
                <p className="text-center price-text-1">
                  Permanent Life Insurance Coverage
                </p>
                <ul className="text-start pb-2">
                  <li>Level Premium</li>
                  <li>Portable</li>
                  <li>Emergency Cash Options</li>
                  <li>Guarantee Coverage Amount</li>
                </ul>
                <div className="black-strip mb-2">FPAR (Optional)</div>
                <ul className="text-start pb-2">
                  <li>
                    Compound Interest
                    <ul
                      className="text-start pb-2"
                      style={{ listStyle: "disc" }}
                    >
                      <li>Current Rate: 4.5%</li>
                      <li>Guaranteed Rate: 2.7%</li>
                    </ul>
                  </li>
                  <li>No Investment Risk</li>
                  <li>Income for Life Option</li>
                </ul>
                {showButtons[1] ? (
                  <div className="text-center">
                    <a
                      href="https://www.insuranceapplication.com/"
                      className="btn btn-primary btnSeeIfIQualify2 benefits-btn-1"
                      target="_blank"
                    >
                      See If I Qualify
                    </a>
                  </div>
                ) : (
                  <div className="text-center h-btn">
                    <a
                      href="https://www.insuranceapplication.com/"
                      className="btn btn-primary btnSeeIfIQualify2 benefits-btn-1"
                      target="_blank"
                    >
                      See If I Qualify
                    </a>
                  </div>
                )}
              </div>
            </div>
          )}
          <div
            className="col-md-4 mx-auto"
            onMouseEnter={(e) => onMouseEnterHandler(3)}
            onMouseLeave={(e) => onmouseleaveHandler(3)}
          >
            <div className="col-11 mx-auto box-cont">
              <div
                className="title-1 text-center"
                style={{ backgroundColor: "#ABABAB", borderColor: "#ABABAB" }}
              >
                PREFERRED
              </div>
              <div className="price-1 text-center">
                $<span>50,000</span>
              </div>
              <p className="text-center price-text-1">
                Permanent Life Insurance Coverage
              </p>
              <ul className="text-start pb-2">
                <li>Level Premium</li>
                <li>Portable</li>
                <li>Emergency Cash Options</li>
                <li>Guarantee Coverage Amount</li>
              </ul>
              <div className="black-strip mb-2">FPAR (Optional)</div>
              <ul className="text-start pb-2">
                <li>
                  Compound Interest
                  <ul className="text-start pb-2" style={{ listStyle: "disc" }}>
                    <li>Current Rate: 4.5%</li>
                    <li>Guaranteed Rate: 2.7%</li>
                  </ul>
                </li>
                <li>No Investment Risk</li>
                <li>Income for Life Option</li>
              </ul>
              {showButtons[2] ? (
                <div className="text-center">
                  <a
                    href="https://www.insuranceapplication.com/"
                    className="btn btn-primary btnSeeIfIQualify2 benefits-btn-1"
                    target="_blank"
                  >
                    See If I Qualify
                  </a>
                </div>
              ) : (
                <div className="text-center h-btn">
                  <a
                    href="https://www.insuranceapplication.com/"
                    className="btn btn-primary btnSeeIfIQualify2 benefits-btn-1"
                    target="_blank"
                  >
                    See If I Qualify
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const submitFormdata = (event) => {
    submit(event, formData);
  };

  return (
    <div className="benefitForm-section">
      <Card.Body>
        <Form
          id="form_benefits"
          className="benefits"
          noValidate
          onSubmit={submitFormdata}
        >
          <div className={isCapitalLegacy ? "section-group" : "section-group2"}>
            {isCapitalLegacy ? capitalBenefits() : seniorBenefits()}
          </div>

          <p className="text-center mt-2">
            You Have Completed the Benefits Portion of the BPG.
          </p>
          {formData["age"] >= 55 && plannerData["bpg_access"] != 2 ? (
            <div className="text-center mt-2 mb-4">
              <button
                className="btn-next btn question-next w-auto"
                type="submit"
              >
                Enter Retirement Section
              </button>
            </div>
          ) : (
            <div className="text-center mt-2 mb-4 ">
              <button
                className="btn-next btn question-next w-autow-100"
                type="submit"
              >
                Continue
              </button>
            </div>
          )}
        </Form>
      </Card.Body>
    </div>
  );
};

export default BenefitTestForm;
